import { Outlet, useLocation } from 'react-router-dom';
import NavBar from 'components/Navbar';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { notification } from 'antd';
import {
  DashboardOutlined,
  TransactionOutlined,
  SettingOutlined,
  ScheduleOutlined,
  LinkOutlined,
  HddOutlined,
  BlockOutlined,
  BankOutlined,
  DollarOutlined,
  FileTextOutlined,
  IdcardOutlined,
  ShoppingCartOutlined,
  StopOutlined,
  SafetyCertificateOutlined,
  KeyOutlined,
  CreditCardOutlined,
  DiffOutlined,
  ApartmentOutlined,
  SecurityScanOutlined,
  UserOutlined,
  UsergroupAddOutlined,
  AccountBookOutlined,
} from '@ant-design/icons';
import useWindowSize from 'utils/useWindowSize';
import { getUsersRole } from 'utils/services';
import { StoreIcon } from 'assets/icons';
import { filterSidebarMenus } from 'utils/featureAccess';
import { isShopifyBinDiscountRealmBypass } from 'utils/binDiscountAccess';
export default function Main() {
  const location = useLocation();
  const { userStores, store } = useSelector((state) => state.company);
  const isLinkedAccountExist = userStores?.find((obj) => obj?.linkedAccounts?.length > 0);
  const { isPlatformAccount, isMerchantAccount, isPim, isSubscriptionsModuleAccessOnly, isCopilotAdmin } = getUsersRole();

  const subscriptionsSideBarModules = [
    {
      title: 'Subscriptions',
      screenTitle: 'Subscriptions',
      icon: <ScheduleOutlined />,
      url: '/subscriptions',
      sabMenus: [
        {
          url: '/subscriptions',
          title: 'Subscriptions',
          screenTitle: 'Subscriptions',
          icon: <ScheduleOutlined />,
          wholeLink: <NavLink to='/subscriptions'>Subscriptions</NavLink>,
        },
        ...(!isPim
          ? [
              {
                url: '/subscriptions/product',
                title: 'Products',
                screenTitle: 'Products',
                icon: <DiffOutlined />,
                wholeLink: <NavLink to='/subscriptions/product'>Products</NavLink>,
              },
              {
                url: '/subscriptions/plan',
                title: 'Plans',
                screenTitle: 'Plans',
                icon: <DollarOutlined />,
                wholeLink: <NavLink to='/subscriptions/plan'>Plans</NavLink>,
              },
              {
                url: '/subscriptions/invoice',
                title: 'Invoices',
                screenTitle: 'Invoices',
                icon: <FileTextOutlined />,
                wholeLink: <NavLink to='/subscriptions/invoice'>Invoices</NavLink>,
              },
              {
                url: '/subscriptions/customer',
                title: 'Customers',
                screenTitle: 'Customers',
                icon: <UserOutlined />,
                wholeLink: <NavLink to='/subscriptions/customer'>Customers</NavLink>,
              },
            ]
          : []),
      ],
    },
  ];
  const sideBarMenus = [
    {
      title: 'Dashboard',
      screenTitle: 'Dashboard',
      icon: <DashboardOutlined />,
      url: '/dashboard',
      wholeLink: <NavLink to='/dashboard'>Dashboard</NavLink>,
    },
    {
      title: 'Transactions',
      screenTitle: 'Transactions',
      icon: <TransactionOutlined />,
      url: '/transactions',
      wholeLink: <NavLink to='/transactions'>Transactions</NavLink>,
    },
    ...subscriptionsSideBarModules,
    {
      title: 'Billing Engine',
      screenTitle: 'Billing Engine',
      icon: <AccountBookOutlined />,
      url: '/billing-engine',
      sabMenus: [
        {
          url: '/billing-engine/meter',
          title: 'Meter',
          screenTitle: 'Meter',
          icon: <DashboardOutlined />,
          wholeLink: <NavLink to='/billing-engine/meter'>Meter</NavLink>,
        },
        {
          url: '/billing-engine/pricing-model',
          title: 'Pricing Model',
          screenTitle: 'Pricing Model',
          icon: <DollarOutlined />,
          wholeLink: <NavLink to='/billing-engine/pricing-model'>Pricing Model</NavLink>,
        },
      ],
    },
    {
      title: 'XShield',
      screenTitle: 'XShield',
      icon: <SafetyCertificateOutlined />,
      url: '/x-shield',
      sabMenus: [
        {
          url: '/x-shield/block-list',
          title: 'Block List',
          screenTitle: 'Block List',
          icon: <StopOutlined />,
          wholeLink: <NavLink to='/x-shield/block-list'>Block List</NavLink>,
        },
        {
          url: '/x-shield/rules',
          title: 'Rules',
          screenTitle: 'Rules',
          icon: <SecurityScanOutlined />,
          wholeLink: <NavLink to='/x-shield/rules'>Rules</NavLink>,
        },
        {
          url: '/x-shield/performance',
          title: 'Performance',
          screenTitle: 'Performance',
          icon: <DashboardOutlined />,
          wholeLink: <NavLink to='/x-shield/performance'>Performance</NavLink>,
        },
      ],
    },
    {
      title: 'Payment Intents',
      screenTitle: 'Payment Intents',
      icon: <HddOutlined />,
      url: '/paymentIntent',
      wholeLink: <NavLink to='/paymentIntent'>Payment Intents</NavLink>,
    },
    {
      title: 'Payment Links',
      screenTitle: 'Payment Links',
      icon: <LinkOutlined />,
      url: '/paymentlink',
      wholeLink: <NavLink to='/paymentlink'>Payment Links</NavLink>,
    },
    ...(isPlatformAccount || (isMerchantAccount && isLinkedAccountExist)
      ? [
          {
            title: 'Linked Accounts',
            screenTitle: 'Linked Accounts',
            icon: <BlockOutlined />,
            url: '/linked_account',
            wholeLink: <NavLink to='/linked_account'>Linked Accounts</NavLink>,
          },
        ]
      : []),
    {
      title: 'Payment Routing',
      screenTitle: 'Payment Routing',
      icon: <ApartmentOutlined />,
      url: '/payment-routing',
      wholeLink: <NavLink to='/payment-routing'>Payment Routing</NavLink>,
    },
    {
      title: 'Invoices',
      screenTitle: 'Invoices',
      icon: <FileTextOutlined />,
      url: '/invoice/aggregator',
      sabMenus: [
        {
          url: '/invoice/aggregator',
          title: 'Aggregator Invoices',
          screenTitle: 'Aggregator Invoices',
          icon: <FileTextOutlined />,
          wholeLink: <NavLink to='/invoice/aggregator'>Aggregator Invoices</NavLink>,
        },
        {
          url: '/invoice/paylater',
          title: 'Paylater Invoices',
          screenTitle: 'Paylater Invoices',
          icon: <FileTextOutlined />,
          wholeLink: <NavLink to='/invoice/paylater'>Paylater Invoices</NavLink>,
        },
      ],
    },
    ...(isCopilotAdmin
      ? [
          {
            title: 'Users',
            screenTitle: 'Users',
            icon: <UsergroupAddOutlined />,
            url: '/users',
            wholeLink: <NavLink to='/users'>Users</NavLink>,
          },
        ]
      : []),
    {
      title: 'Account Settings',
      screenTitle: 'Account Settings',
      icon: <SettingOutlined />,
      url: '/setting',
      sabMenus: [
        {
          url: '/setting/store',
          title: 'Store Info',
          screenTitle: 'Store Info',
          icon: <ShoppingCartOutlined />,
          wholeLink: <NavLink to='/setting/store'>Store Info</NavLink>,
        },
        {
          url: '/setting/gateway',
          title: 'Gateways',
          screenTitle: 'Gateways',
          icon: <IdcardOutlined />,
          wholeLink: <NavLink to='/setting/gateway'>Gateways</NavLink>,
        },
        ...((store?.ecommerceChannel?.type !== 'shopify-public-app' && store?.ecommerceChannel?.type !== 'shopify-cc-app') ||
        isShopifyBinDiscountRealmBypass()
          ? [
              {
                url: '/setting/bin-discount',
                title: 'Bin Discounts',
                screenTitle: 'Bin Discounts',
                icon: <CreditCardOutlined />,
                wholeLink: <NavLink to='/setting/bin-discount'>Bin Discounts</NavLink>,
              },
            ]
          : []),
        {
          url: '/setting/subscriptionDetails',
          title: 'Subscription',
          screenTitle: 'Subscription',
          icon: <DiffOutlined />,
          wholeLink: <NavLink to='/setting/subscriptionDetails'>Subscription</NavLink>,
        },
        {
          url: '/setting/billing',
          title: 'Billing & Usage',
          screenTitle: 'Billing & Usage',
          icon: <FileTextOutlined />,
          wholeLink: <NavLink to='/setting/billing'>Billing & Usage</NavLink>,
        },
        // {
        //   url: `/setting/payment-channels`,
        //   title: 'Payment Channels',
        //   screenTitle: 'Payment Channels',
        //   icon: <BankOutlined />,
        //   wholeLink: <NavLink to='/setting/payment-channels'>Payment Channels</NavLink>,
        // },
      ],
    },
  ];
  const filteredMenus = isSubscriptionsModuleAccessOnly ? subscriptionsSideBarModules : filterSidebarMenus(store, sideBarMenus);
  return (
    <NavBar NavMenus={filteredMenus}>
      <Outlet />
    </NavBar>
  );
}
